import { State } from '../../../store/reducers';

const getRecommendationsCatalog = (state: State) => state?.recommendationsCatalog;

export const getActiveChip = (recommendationsCatalogId: number) => (state: State) => {
  const activeChip = `activeChip${recommendationsCatalogId}`;

  return getRecommendationsCatalog(state)?.[activeChip];
};
